import request from '@/utils/request'

export function updateInviteStageRewardCfg(data) {
  return request({
    url: 'api/v1/invite-stage/updateInviteStageRewardCfg',
    method: 'post',
    data: data
  })
}

export function getInviteStageRewardList(data) {
  return request({
    url: 'api/v1/invite-stage/getList',
    method: 'post',
    data: data
  })
}

export function getFirstCfg(data) {
  return request({
    url: 'api/v1/invite-stage/getFirst',
    method: 'post',
    data: data
  })
}

export function delFirstCfg(data) {
  return request({
    url: 'api/v1/invite-stage/delFirst',
    method: 'delete',
    data: data
  })
}

